<template>
  <iframe
    src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDJf6rlm0wPgNJEZqKbcZSD_i5YK7rzQD4&q=Snetterton+Auto+Services"
    width="100%"
    :height="height"
    style="border:0;"
    allowfullscreen=""
    referrerpolicy="no-referrer-when-downgrade"
  ></iframe>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '450'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/GoogleMapsEmbed.vue